// src/apiAdmin.ts
import axios from "axios";
import { SERVER_URL } from "./config";

export const adminApi = axios.create({
  baseURL: `${SERVER_URL}/api/admin`,
  withCredentials: true,
});

const rootApi = axios.create({
  baseURL: `${SERVER_URL}/api`,
  withCredentials: true,
});

let adminAccessToken: string | null = null;

export function setAdminToken(token: string | null) {
  adminAccessToken = token;
  if (token) {
    adminApi.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete adminApi.defaults.headers.common.Authorization;
  }
}

export function getAdminToken() {
  return adminAccessToken;
}
export function clearAdminToken() {
  setAdminToken(null);
}

try {
  if (typeof window !== "undefined") {
    const saved = localStorage.getItem("admin-token");
    if (saved) setAdminToken(saved);
  }
} catch { /* no-op */ }

let csrfInFlight: Promise<void> | null = null;
let hasCsrf = false;

async function fetchCsrfOnce(): Promise<void> {
  const { data } = await rootApi.get("/csrf-token");
  adminApi.defaults.headers.common["X-CSRF-Token"] = data.csrfToken;
  hasCsrf = true;
}

export function getAdminCsrf(): Promise<void> {
  if (hasCsrf) return Promise.resolve();
  if (!csrfInFlight) {
    csrfInFlight = fetchCsrfOnce()
      .catch(() => {})
      .finally(() => {
        csrfInFlight = null;
      });
  }
  return csrfInFlight || Promise.resolve();
}

adminApi.interceptors.request.use(async (config) => {
  const method = (config.method || "get").toLowerCase();
  if (["post", "put", "patch", "delete"].includes(method)) {
    await getAdminCsrf();
  }
  return config;
});
